import type { TFunction } from "i18next";
import { CompletionStatus } from "@utils/completion_status.ts";
import type { AnyTask } from "@/types/task";
import useTranslation from "@hooks/use_translation";
import { timeAgo } from "@utils/time_ago";

const taskStatusText = (task: AnyTask, t: TFunction, tTimeAgo: TFunction): string => {
  if (task.status === CompletionStatus.Complete) {
    return t("progress.complete");
  } else if (task.status === CompletionStatus.AlmostFinished) {
    return t("progress.almostFinished");
  } else if (task.status === CompletionStatus.InProgress) {
    return t("progress.inProgress");
  } else if ("created_at" in task && task.created_at) {
    return timeAgo(task.created_at, tTimeAgo);
  } else {
    return t("progress.notStarted");
  }
};

const useTaskStatusText = (task: AnyTask): string => {
  const { t } = useTranslation("user");
  const { t: tTimeAgo } = useTranslation("timeAgo");
  return taskStatusText(task, t, tTimeAgo);
};

export default useTaskStatusText;
